import { useNavigate } from 'react-router-dom';

import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { useScopedTranslate } from '@locale/translate';

import { Subtitle, Title } from './common';

import { routePaths } from '../navigation';

export const PasswordSuccessPage = () => {
  const navigate = useNavigate();
  const { t } = useScopedTranslate(locale);

  return (
    <Stack space={6}>
      <Stack>
        <Title>{t('passwordSuccess')}</Title>
        <Subtitle>{t('setToSignIn')}</Subtitle>
      </Stack>
      <Stack space={4}>
        <Button variant="primary" text={t('signIn')} onClick={() => navigate(routePaths.signin)} />
      </Stack>
    </Stack>
  );
};

const locale = {
  en: {
    passwordSuccess: 'Password successfully set',
    setToSignIn: 'You are all set to sign in with your email and password',
    signIn: 'Sign in',
  },
};
